<template>
  <div :class="['small-cards', isMobile ? '' : 'small-cards-pc']">
    <div class="nav-content">
      <div class="nav-box">
        <div
          v-for="(item, index) in robotNav.list"
          :key="index"
          class="nav-box-row"
        >
          <div class="nav-box-wrapper nav-link" @click="onClick(item)">
            <div class="nav-image">
              <img :src="item.icon.url" class="nav-img-pic" mode="widthFix" />
            </div>
            <div class="nav-text">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import robotNavMixin from './robot-nav-mixin.js';
/**
 * @component 机器人导航 - 小卡片型
 */
export default {
  mixins: [robotNavMixin],
};
</script>

<style lang="less" scoped>
.small-cards {
  .nav-content {
    display: flex;
    .nav-box {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      .nav-box-row {
        width: calc(25% - 12px);
        height: 0;
        padding-bottom: calc(25% - 12px);
        margin-right: 16px;
        margin-bottom: 10px;
        position: relative;
        box-shadow: 0 1px 10px 0 #e1e6f0;
        background: #fff;
        border-radius: 6px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .nav-box-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          border-radius: 6px;
          .nav-image {
            width: 32px;
            height: 32px;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            &-pic{
              max-width: 100%;
            }
          }
          .nav-text {
            font-size: 13px;
            line-height: 18px;
            margin-top: 4px;
          }
        }
      }
    }
  }
}
.small-cards-pc {
  width: 336px;
  .nav-content {
    margin-top: 2px;
  }
}
</style>
